import { render, staticRenderFns } from "./formEdit.vue?vue&type=template&id=6834f9d6&scoped=true&"
import script from "./formEdit.vue?vue&type=script&lang=js&"
export * from "./formEdit.vue?vue&type=script&lang=js&"
import style0 from "./formEdit.vue?vue&type=style&index=0&id=6834f9d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834f9d6",
  null
  
)

export default component.exports